<template>
<div id="catalogo_mt" >
    <v-power-catalogo :parametros="parametros" />
</div>
</template>

<script>
import powerCatalogo from "@/views/apendices/layout.vue";
export default {
    components: {
        "v-power-catalogo": powerCatalogo
    },
    mounted() {},

    data: () => ({
        fab: false,
        parametros: {
            url_actions: "apendices/",
            url_list: "apendices/lista/",
            tabla: 12,
            title: "REGULACIONES Y RESTRICCIONES NO ARANCELARIAS",
            columns: ["clave", "descripcion", "secretaria", "actions"],
            options: {
                filterable: ["clave", "descripcion", "secretaria"],
                sortable: ["clave", "descripcion", "secretaria"],

                headings: {
                    clave: "Clave",
                    descripcion: "Descripción",
                    secretaria: "Secretaría",
                    actions: "Operaciones"
                }
            },
            camposexcel: {
                Clave: "clave",
                Descripción: "descripcion",
                Secretaría: "secretaria"
            },
            encabezadoLayout: {
                clave: "clave",
                descripcion: "descripcion",
                secretaria: "secretaria"
            },
            camposLayout: [{
                clave: "[Clave de la Regulación]",
                descripcion: "[Descripció de la Regulación]",
                secretaria: "[Nombre de la Secretaría]"
            }],
            model: {
                id: 0,
                clave: "",
                descripcion: "",
                secretaria: ""
            },
            form: {
                clave: {
                    requiered: true,
                    label: "Clave",
                    value: "",
                    maxlen: 10
                },
                descripcion: {
                    requiered: true,
                    label: "Descripción",
                    value: "",
                    maxlen: 500
                },
                secretaria: {
                    requiered: true,
                    label: "Secretaría",
                    value: "",
                    maxlen: 200
                }
            },
            breadcrumbs: [{
                    text: "Inicio",
                    disabled: false,
                    to: "/home"
                },
                {
                    text: "Utilerías",
                    disabled: true,
                    to: ""
                },
                {
                    text: "Apendices",
                    disabled: true,
                    to: ""
                }
            ]
        }
    })
};
</script>
<style scoped>
.VueTables >>> thead th {
  white-space: normal !important;
}

.VueTables >>> tbody td{
  white-space: normal !important;
}
</style>